import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import OurStory from "@/components/OurStory";
import TeamSection from "@/components/TeamSection";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const About = () => {
  return (
    <>
      <SeoHead
        title="About Us | AI-labbet"
        description="Learn about AI-labbet's mission to help organizations navigate AI transformation with strategy, governance, and education."
        path="/about"
      />
      
      <div className="min-h-screen bg-background">
        <Header />
        <PageBreadcrumb currentPage="About" />
        <main>
          <OurStory />
          <TeamSection />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default About;
